export default __webpack_public_path__ + "static/media/smiley5-open.05e681ac.svg";